import type { Infer } from 'superstruct';
import { object, string } from 'superstruct';
import { notEmpty } from '../../../../form';

export const MfaSetupValidation = object({
  code: notEmpty(string()),
});

export type MfaSetupFields = Infer<typeof MfaSetupValidation>;
